<script lang="ts">
  import { getContext } from "svelte";
  import BusinessUpdatesList from "./BusinessUpdatesList.svelte";
  import { formatDate } from "../utils";
  import { truncate } from "/shared/utils.js";
  import { BusinessUpdateSerialiser as Update } from "/apiFactory/api";

  export let update: Update;

  const truncated = truncate(update.body, 15);
</script>

<style>
  /* Custom button styles: We want an element which functions
   * semantically as a button but is styled as an anchor tag.
   */
  button {
    background: none !important;
    border: none;
    padding-left: 0rem;
    font-weight: 500;
  }

  .card-title {
    text-transform: uppercase;
    margin: 0;
    font-size: 1.5rem;
  }
</style>

<div class="mt-2 mb-3">
  {#if update.image_uuid}
    <div
      class="text-white border-0 gradient-overlay embed-responsive embed-responsive-4by3">
      <!-- svelte-ignore a11y-missing-attribute -->
      <img
        class="card-img-top embed-responsive-item"
        data-blink-uuid={update.image_uuid}
        data-blink-scale-mode="scale-crop" />
      <div class="card-img-overlay d-flex align-items-end pb-1 pl-2">
        <div class="overlay-content">
          <h5 class="card-title font-weight-normal uppercase">
            {@html formatDate(update.created)}
          </h5>
        </div>
      </div>
    </div>
  {:else}
    <div>
      <h5 class="card-title font-weight-normal uppercase">
        {@html formatDate(update.created)}
      </h5>
    </div>
  {/if}
  <div
    class="text-muted mb-0 {update.image_uuid ? 'pt-3' : 'pt-2'}"
    style="white-space: pre-wrap;">
    {truncated}
  </div>
  <!-- Allow user to reveal full update -->
  {#if truncated != update.body}
    <button class="pt-0 text-primary" on:click>Read more</button>
  {/if}
</div>
